import { render, staticRenderFns } from "./SchimmerRectangle.vue?vue&type=template&id=2b48406e&scoped=true&lang=pug"
import script from "./SchimmerRectangle.vue?vue&type=script&lang=js"
export * from "./SchimmerRectangle.vue?vue&type=script&lang=js"
import style0 from "./SchimmerRectangle.vue?vue&type=style&index=0&id=2b48406e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b48406e",
  null
  
)

export default component.exports